<mat-card appearance="outlined" *ngIf="isSuperAdmin()">
    <mat-card-header>
        <mat-icon class="card-header-icon" mat-card-avatar>admin_panel_settings</mat-icon>
        <mat-card-title>Organization Settings</mat-card-title>
        <mat-card-subtitle>Super Admin only — controls DTR Copilot for every Analyst in your organization</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content style="padding-top: 16px;">
        <div *ngIf="orgSettingsLoading" style="color: gray;">Loading…</div>
        <div *ngIf="orgSettingsError" style="color: #b00020;">
            Couldn't load organization settings.
            <button mat-button (click)="loadOrgSettings()">Retry</button>
        </div>
        <ng-container *ngIf="orgSettings && !orgSettingsLoading">
            <div style="display: flex; align-items: center; gap: 16px;">
                <mat-slide-toggle
                    [checked]="orgSettings.enabled"
                    [disabled]="orgSettingsSaving"
                    (change)="onOrgEnabledToggle($event.checked)"
                    color="primary">
                    Enable DTR Copilot (organization-wide)
                </mat-slide-toggle>
                <span style="color: gray; font-size: 13px;" *ngIf="!orgSettings.enabled">
                    Disabled — no Analyst in your organization can use Copilot until this is turned on.
                </span>
            </div>

            <div style="margin-top: 24px;" [style.opacity]="orgSettings.enabled ? 1 : 0.5">
                <div style="font-weight: 500; margin-bottom: 4px;">
                    Daily usage cap per Analyst
                </div>
                <div style="color: gray; font-size: 13px; margin-bottom: 8px;">
                    {{ formatCredits(orgSettings.currentCapCredits) }} credits / day per Analyst
                </div>
                <mat-slider #capSlider
                    min="1" [max]="orgSettings.steps.length" step="1"
                    discrete showTickMarks
                    [displayWith]="formatCapStepLabel"
                    [disabled]="!orgSettings.enabled || orgSettingsSaving"
                    style="width: 320px;">
                    <input matSliderThumb
                        [value]="orgSettings.currentCapStep"
                        (valueChange)="onCapStepChange($event)">
                </mat-slider>
                <!-- Positioned to match the slider's own rendered tick marks exactly
                     (measured live — see measureTickLabelPositions()), not assumed via
                     flex spacing. -->
                <div #tickLabelRow style="position: relative; width: 320px; height: 14px; margin-top: 2px;">
                    <span *ngFor="let credits of orgSettings.steps; let i = index"
                          style="position: absolute; top: 0; font-size: 11px; color: gray; white-space: nowrap; transform: translateX(-50%);"
                          [style.left.px]="tickLabelPositions[i]">
                        {{ formatCredits(credits) }}
                    </span>
                </div>
            </div>

            <div style="margin-top: 24px;" [style.opacity]="orgSettings.enabled ? 1 : 0.5">
                <div style="font-weight: 500; margin-bottom: 4px;">
                    Auto-Accept Quality Threshold
                </div>
                <div style="color: gray; font-size: 13px; margin-bottom: 8px;">
                    {{ orgSettings.autoAcceptQualityPct }}% — minimum config quality score at which
                    Copilot treats an already-built config as validated and skips unnecessary rework.
                </div>
                <mat-slider
                    [min]="orgSettings.autoAcceptQualityMin" [max]="orgSettings.autoAcceptQualityMax" step="1"
                    discrete showTickMarks
                    [displayWith]="formatQualityPct"
                    [disabled]="!orgSettings.enabled || orgSettingsSaving"
                    style="width: 320px;">
                    <input matSliderThumb
                        [value]="orgSettings.autoAcceptQualityPct"
                        (valueChange)="onQualityThresholdChange($event)">
                </mat-slider>
            </div>
        </ng-container>
    </mat-card-content>
</mat-card>

<mat-card appearance="outlined" *ngIf="isSuperAdmin()" style="margin-top: 16px;">
    <mat-card-header>
        <mat-icon class="card-header-icon" mat-card-avatar>rate_review</mat-icon>
        <mat-card-title>Analyst Feedback</mat-card-title>
        <mat-card-subtitle>Free-form comments from the post-save survey — Super Admin only, not fed into the knowledge base</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content style="padding-top: 16px;">
        <div *ngIf="feedbackLoading" style="color: gray;">Loading…</div>
        <div *ngIf="feedbackError" style="color: #b00020;">
            Couldn't load feedback.
            <button mat-button (click)="loadFeedback()">Retry</button>
        </div>
        <div *ngIf="!feedbackLoading && !feedbackError && feedbackEntries.length === 0" style="color: gray;">
            No feedback comments yet.
        </div>
        <div *ngFor="let entry of feedbackEntries" style="padding: 10px 0; border-bottom: 1px solid #eee;">
            <div style="font-size: 12px; color: gray;">
                {{ entry.ts | date:'medium' }} — {{ transformTypeLabel(entry.transformType) }} — {{ entry.sessionId }}
            </div>
            <div style="white-space: pre-wrap;">{{ entry.feedbackText }}</div>
        </div>
    </mat-card-content>
</mat-card>
